export default "__VITE_ASSET__Bx0_gKi3__"